import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';

export class InspectionPlanTaskMitigationColumn implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Inspection Plan Task Mitigation Column';
  readonly apiRoute: string = CONFIG.apiRoutes.inspectionPlanTaskMitigationColumn;

  inspectionPlanTaskMitigationColumnId: string;
  inspectionPlanTaskId: string;
  mitigationColumnId: string;
  cellText: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.inspectionPlanTaskMitigationColumnId = data.inspectionPlanTaskMitigationColumnId;
    this.inspectionPlanTaskId = data.inspectionPlanTaskId;
    this.mitigationColumnId = data.mitigationColumnId;
    this.cellText = data.cellText;
  }
}
